module.exports = __webpack_public_path__ + "static/img/04942724.0ddbc4c3.png";